import { createMuiTheme } from '@material-ui/core/styles';
var HyreTheme = createMuiTheme({
  mode: 'dark',
  typography: {
    fontFamily: ['Lato', 'Rubik', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(',')
  },
  palette: {
    primary: {
      // light: '#B7ECEC',
      light: '#47C1BF',
      main: '#00848E',
      dark: '#003135',
      contrastText: '#fff',
      border: '#DDD'
    },
    neutral: {
      light: '#F4F6F8',
      main: '#E0F5F5',
      dark: '#212B36',
      green: '#00A7A4'
    },
    secondary: {
      light: '#fcfcfc',
      main: '#637381',
      dark: '#212B36'
    },
    error: {
      light: '#FEAD9A',
      main: '#DE3618',
      dark: '#BF0711'
    },
    warning: {
      light: '#FFC58B',
      main: '#F49342',
      dark: '#C05717'
    },
    info: {
      light: '#B4E1FA',
      main: '#006FBB',
      dark: '#084E8A'
    },
    success: {
      light: '#BBE5B3',
      main: '#50B83C',
      dark: '#108043'
    },
    text: {
      disabled: '#F6F6F6'
    }
  }
});
export { HyreTheme };